import { UserTokenContextType } from '@/features/user-token-provider/types'

import { PUBLIC_NAUTILUS_CLIENT_API_URL } from '@/app/_constants/urls'
import { setUrlParams } from '@/app/_utils/set-url-params'

import { SearchAPIResponse } from '../types'

interface Props {
    query: string
    userToken: UserTokenContextType['userToken']
    signal: AbortSignal | undefined
}

export default async function fetchSearchResult({ query, userToken, signal }: Props) {
    try {
        const url = setUrlParams(`${PUBLIC_NAUTILUS_CLIENT_API_URL}/catalog/search?ut=${userToken}&query=${query}`)
        const response = await fetch(url, {
            signal,
        })

        if (!response.ok) throw new Error('Search results is not OK.')

        const result: SearchAPIResponse = await response.json()

        return result
    } catch (error) {
        throw new Error(`Error fetching user profile info: ${error}`)
    }
}
